import React from 'react';
import styles from '../index.module.scss';
import Section from './section';

// 基础统计信息类型定义（根据接口文档）（不要为为什么字段名是中文，问就是接口就这么定义的，问就是道路自信、理论自信、制度自信）
interface BasicStats {
    车队名称?: string;
    安装车辆数?: number;
    运行车辆数?: number;
    风险车辆数?: number;
    运行总时长?: number;
    运行总里程?: number;
    平均单车运行时间?: number;
    单车平均运行里程?: number;
    平均车速?: number;
    车队最经济车辆?: string;
    疲劳驾驶最多车辆?: string;
    安全评分最高车辆?: string;
    安全评分最低车辆?: string;
    '主动安全设备报警（AEB+BSD）'?: number;
    驾驶员状态DMS报警?: number;
    '超速、急加速、急减速'?: number;
    车队综合风险等级?: string;
}

interface iFleetOverviewTableProps {
    data?: BasicStats;
    fleetName?: string;
}
// 车队概况表格
const FleetOverviewTable = (props: iFleetOverviewTableProps) => {
    const { data = {}, fleetName } = props;
    return (
        <Section title="一、车队概况">
            <div className={styles.overviewTableWrapper}>
                <table className={styles.overviewTable}>
                    <colgroup>
                        <col className={styles.overviewTableColLabel} />
                        <col className={styles.overviewTableColValue} />
                        <col className={styles.overviewTableColLabel} />
                        <col className={styles.overviewTableColValue} />
                        <col className={styles.overviewTableColLabel} />
                        <col className={styles.overviewTableColValue} />
                    </colgroup>
                    <tbody>
                        <tr>
                            <td className={styles.overviewTableLabel}>车队名称</td>
                            <td className={styles.overviewTableValue} colSpan={5}>{fleetName || data.车队名称 || '-'}</td>
                        </tr>
                        <tr>
                            <td className={styles.overviewTableLabel}>服务车辆数</td>
                            <td className={styles.overviewTableValue}>{data.安装车辆数 !== undefined && data.安装车辆数 !== null ? `${data.安装车辆数}辆` : '-'}</td>
                            <td className={styles.overviewTableLabel}>运行车辆数</td>
                            <td className={styles.overviewTableValue}>{data.运行车辆数 !== undefined && data.运行车辆数 !== null ? `${data.运行车辆数}辆` : '-'}</td>
                            <td className={styles.overviewTableLabel}>风险车辆数</td>
                            <td className={styles.overviewTableValue}>{data.风险车辆数 !== undefined && data.风险车辆数 !== null ? `${data.风险车辆数}辆` : '-'}</td>
                        </tr>
                        <tr>
                            <td className={styles.overviewTableLabel}>车队综合风险等级</td>
                            <td className={styles.overviewTableValue} colSpan={5}>{data.车队综合风险等级 || '-'}</td>
                        </tr>
                        <tr>
                            <td className={styles.overviewTableLabel}>运行总时长</td>
                            <td className={styles.overviewTableValue}>{data.运行总时长 !== undefined && data.运行总时长 !== null ? `${data.运行总时长}小时` : '-'}</td>
                            <td className={styles.overviewTableLabel}>运行总里程</td>
                            <td className={styles.overviewTableValue}>{data.运行总里程 !== undefined && data.运行总里程 !== null ? `${data.运行总里程}公里` : '-'}</td>
                            <td className={styles.overviewTableLabel}>平均单车运行时长</td>
                            <td className={styles.overviewTableValue}>{data.平均单车运行时间 !== undefined && data.平均单车运行时间 !== null ? `${data.平均单车运行时间}小时` : '-'}</td>
                        </tr>
                        <tr>
                            <td className={styles.overviewTableLabel}>单车平均运行里程</td>
                            <td className={styles.overviewTableValue}>{data.单车平均运行里程 !== undefined && data.单车平均运行里程 !== null ? `${data.单车平均运行里程}公里` : '-'}</td>
                            <td className={styles.overviewTableLabel}>平均车速</td>
                            <td className={styles.overviewTableValue}>{data.平均车速 !== undefined && data.平均车速 !== null ? `${data.平均车速}km/h` : '-'}</td>
                            <td className={styles.overviewTableLabel}>车队最经济车辆</td>
                            <td className={styles.overviewTableValue}>{data.车队最经济车辆 || '-'}</td>
                        </tr>
                        <tr>
                            <td className={styles.overviewTableLabel}>疲劳驾驶最多车辆</td>
                            <td className={styles.overviewTableValue}>{data.疲劳驾驶最多车辆 || '-'}</td>
                            <td className={styles.overviewTableLabel}>安全评分最高车辆</td>
                            <td className={styles.overviewTableValue}>{data.安全评分最高车辆 || '-'}</td>
                            <td className={styles.overviewTableLabel}>安全评分最低车辆</td>
                            <td className={styles.overviewTableValue}>{data.安全评分最低车辆 || '-'}</td>
                        </tr>
                        <tr>
                            <td className={styles.overviewTableLabel}>主动安全设备报警（AEB+BSD）</td>
                            <td className={styles.overviewTableValue}>{data['主动安全设备报警（AEB+BSD）'] !== undefined && data['主动安全设备报警（AEB+BSD）'] !== null ? `${data['主动安全设备报警（AEB+BSD）']}次/百公里` : '-'}</td>
                            <td className={styles.overviewTableLabel}>驾驶员状态DMS报警</td>
                            <td className={styles.overviewTableValue}>{data.驾驶员状态DMS报警 !== undefined && data.驾驶员状态DMS报警 !== null ? `${data.驾驶员状态DMS报警}次/百公里` : '-'}</td>
                            <td className={styles.overviewTableLabel}>超速、急加速、急减速</td>
                            <td className={styles.overviewTableValue}>{data['超速、急加速、急减速'] !== undefined && data['超速、急加速、急减速'] !== null ? `${data['超速、急加速、急减速']}次/百公里` : '-'}</td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </Section>

    );
};

export default FleetOverviewTable;
